import { render, staticRenderFns } from "./search-overview.vue?vue&type=template&id=28bb4c24&scoped=true"
import script from "./search-overview.vue?vue&type=script&lang=js"
export * from "./search-overview.vue?vue&type=script&lang=js"
import style0 from "./search-overview.vue?vue&type=style&index=0&id=28bb4c24&prod&lang=scss"
import style1 from "./search-overview.vue?vue&type=style&index=1&id=28bb4c24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bb4c24",
  null
  
)

export default component.exports